import { Stack, Typography } from "@mui/material";
import PercentageIndicator from "./PercentageIndicator";

export default function CpcCell({ cpc }) {
  if (!cpc) return "-";
  return (
    <Stack
      direction="column"
      spacing={0.5}
      alignItems="center"
      justifyContent="center"
      sx={{ width: "100%", height: "100%" }}
    >
      <Stack direction="row" spacing={0.5} alignItems="center">
        <Typography
          variant="body2"
          fontWeight={700}
          sx={{ color: "#000000DE", fontSize: "14px" }}
        >
          ${cpc?.value?.toFixed(2)}
        </Typography>
        {cpc?.benchmark && (
          <Typography
            variant="body2"
            fontWeight={400}
            sx={{ color: "#00000099", fontSize: "14px" }}
          >
            / ${cpc?.benchmark}
          </Typography>
        )}
      </Stack>
      <PercentageIndicator value={cpc?.change} />
    </Stack>
  );
}
